'use client';

import React, { useState, useMemo } from 'react';
import ProductModelSwitcher from "./ProductModelSwitcher/ProductModelSwitcher";
import ModelComparison from "./ModelComparison/ModelComparison";
import ProductScrollMotion from "./ProductScrollMotion";

export default function ClientProductView({ variantsData, initialVariantId }) {
  const [activeVariantId, setActiveVariantId] = useState(
    initialVariantId || (variantsData.length > 0 ? variantsData[0].id : null)
  );

  const activeCar = useMemo(() => {
    return variantsData.find(v => v.id === activeVariantId) || variantsData[0];
  }, [variantsData, activeVariantId]);

  const images = activeCar?.exterior ? [
    activeCar.exterior.image_1,
    activeCar.exterior.image_2,
    activeCar.exterior.image_3,
    activeCar.exterior.image_4,
    activeCar.exterior.image_5,
    activeCar.exterior.image_6,
  ].filter(Boolean) : [];

  return (
    <>
      <ProductModelSwitcher
        variants={variantsData}
        activeVariantId={activeVariantId}
        onVariantChange={setActiveVariantId}
      />
      {variantsData && variantsData.length > 1 && (
        <div className="bg-white pt-10 pb-24 relative z-20">
          <div className="text-center mb-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">مقایسه مدل‌ها</h2>
          </div>
          <ModelComparison
            variants={variantsData}
          />
        </div>
      )}
      {images && images.length >= 3 && (
        <ProductScrollMotion images={images.slice(0, 3)} activeCar={activeCar} />
      )}
    </>
  );
}
